import styled from 'styled-components';

import { ANIM, COLORS } from '../../theme/tokens';
import { Text } from '../Text/Text';

/* The native input is the accessible control (role, keyboard, form semantics); it is
   visually hidden but stays focusable, and the Box is only its paint. The label wraps
   both, so clicking anywhere on the row toggles the input. `position: relative` keeps
   the clipped absolute input inside the row's box. */
export const Root = styled.label<{ $disabled: boolean }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: ${(p) => (p.$disabled ? 'default' : 'pointer')};
  user-select: none;
`;

/* Declared before Box: Box's focus/disabled rules reference it as a sibling. */
export const Input = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
`;

export const Box = styled.span<{ $checked: boolean; $disabled: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  border-radius: 5px;
  border: 1.5px solid ${(p) => (p.$disabled ? COLORS.textFaint : p.$checked ? COLORS.ctaSolid : COLORS.textSubtle)};
  background: ${(p) => (p.$checked ? (p.$disabled ? COLORS.textFaint : COLORS.ctaSolid) : 'transparent')};
  color: ${COLORS.ctaSolidText};
  transition:
    background ${ANIM.INTERACT_MS}ms ease,
    border-color ${ANIM.INTERACT_MS}ms ease;

  /* Keyboard focus lands on the hidden input; paint the ring on its painted twin. */
  ${Input}:focus-visible + & {
    outline: 2px solid ${COLORS.accent};
    outline-offset: 2px;
  }
`;

export const Label = styled(Text)<{ $disabled: boolean }>`
  font-size: 14px;
  line-height: 1.4;
  color: ${(p) => (p.$disabled ? COLORS.textFaint : COLORS.text)};
`;
